import { range } from 'lodash';

import { Skeleton } from '@air/component-skeleton';
import { AirIcon } from '@air/design-icons';
import { ContentCollectionPageHeader } from '@air/feature-content-collection/ui';

const AIR_LOGO_MARK_SIZE_PX = 48;
const SKELETON_FIELD_ROW_COUNT = 3;

export const ContentCollectionSkeleton = () => {
  return (
    <div className="flex h-full flex-col bg-gray-3">
      <ContentCollectionPageHeader>
        <div className="flex w-full justify-between">
          <div className="flex items-center gap-3">
            <Skeleton className="size-12" />
            <Skeleton className="h-6 w-40" />
          </div>
          <AirIcon size={AIR_LOGO_MARK_SIZE_PX} className="text-blue-9" />
        </div>
      </ContentCollectionPageHeader>
      <div className="flex-1 overflow-hidden">
        <div className="relative z-0 flex h-full grow items-end justify-center overflow-y-auto bg-gray-3 pt-8 md:py-8">
          <div className="mt-auto flex w-full flex-col items-center justify-center gap-4 rounded-t-16 border-0 border-gray-5 border-t bg-gray-1 p-4 md:my-auto md:w-[480px] md:rounded-8 md:border">
            <header className="flex w-full flex-col items-center gap-4 border-b border-b-gray-5 py-4 text-center">
              <h1 className="font-semibold text-24 text-gray-11">
                <Skeleton className="h-6 w-40" />
              </h1>
            </header>
            <div className="flex w-full flex-col gap-2 rounded-4 border border-gray-5 bg-gray-3 p-3">
              <h2 className="font-semibold text-14 text-gray-11">
                <Skeleton />
              </h2>
              <ul>
                {range(0, SKELETON_FIELD_ROW_COUNT).map((index) => (
                  <li
                    key={index}
                    className="flex flex-col gap-1 border-b border-b-gray-5 py-3 last:border-b-0 last:pb-0"
                  >
                    <h3 className="flex items-center gap-3 font-medium text-14 text-gray-11">
                      <div className="flex size-6 items-center justify-center">
                        <Skeleton className="size-6" />
                      </div>
                      <span>
                        <Skeleton className="h-6 w-40" />
                      </span>
                    </h3>
                    <div className="pl-9 text-12 text-gray-10">
                      <Skeleton className="h-6 w-40" />
                    </div>
                  </li>
                ))}
              </ul>
            </div>
            <Skeleton className="h-12 w-full" />
            <span className="hidden text-12 text-gray-9 md:block">
              <Skeleton className="h-6 w-40" />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
